import { selectIsStepByStepView } from "@/store/ai-asset-review/ai-asset-review-selectors";
import { useAppSelector } from "@/store/store-hooks";
import { Box, Stack } from "@mui/material";
import type { JSX } from "react";
import { AiReviewListView } from "./ai-review-list-view";
import { AiReviewMainContentHeader } from "./ai-review-main-content-header";
import { AiReviewStepByStepView } from "./ai-review-step-by-step-view";

/** @returns main content component that switches between step-by-step and list views */
export function AiReviewMainContent(): JSX.Element {
  const isStepByStepView = useAppSelector(selectIsStepByStepView);

  return (
    <Stack
      sx={{
        flex: 1,
        maxWidth: 900,
        mx: "auto",
        height: "100%",
        overflow: "hidden",
      }}
    >
      {/* Header with tab buttons */}
      <Stack sx={{ p: 2, pb: 2, flexShrink: 0 }}>
        <AiReviewMainContentHeader />
      </Stack>

      {/* Content area */}
      <Box
        component="div"
        sx={{ p: 2, pt: 2, flex: 1, overflow: "auto", minHeight: 0 }}
      >
        {isStepByStepView ? <AiReviewStepByStepView /> : <AiReviewListView />}
      </Box>
    </Stack>
  );
}
